import { template as template_e6fc53587589451ca57d7501827df27f } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import BsButton from 'eflex/components/bs-button';
import BsTooltip from 'eflex/components/bs-tooltip';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import TaskStatuses from 'eflex/constants/task-statuses';
export default template_e6fc53587589451ca57d7501827df27f(`
<BsButton
  @type="danger"
  @size={{or @size "md"}}
  @onClick={{fn @onTaskComplete TaskStatuses.REJECTED}}
  @disabled={{@disabled}}
  class="jem-status reject-jem-task reject-button text-uppercase text-white px-3 py-2"
  ...attributes
>
  {{#if @notAuthorized}}
    <BsTooltip>
      {{t "notAuthorized"}}
    </BsTooltip>
  {{/if}}
  {{t "reject"}}
</BsButton>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
